









import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import autoBind from 'auto-bind';

@Component
export default class TransparentNavbar extends Vue {
    @Prop({ type: Number, default: 200 }) public opaqueHeight: number;
    @Prop({ type: Boolean, default: false }) public doFade: boolean;

    private pageContentElement: Element;
    private backgroundElement: any;
    private backgroundOpacity: number = -1;

    public constructor() {
        super();
        autoBind(this);
    }

    public async mounted() {
        this.backgroundElement = this.$refs.bgElement;

        const parentPage = this.$parent;
        if (parentPage && parentPage.$children) {
            parentPage.$children.forEach(child => {
                const childElement = child.$el;
                if (childElement.className.indexOf('page-content') >= 0) {
                    this.pageContentElement = childElement;
                    return;
                }
            });
        }

        if (this.pageContentElement) {
            this.pageContentElement.addEventListener('scroll', this.scrollUpdate, false);

            // call scroll update once to set the init value
            this.scrollUpdate();
        }
    }

    public async beforeDestroy() {
        if (this.pageContentElement) {
            this.pageContentElement.removeEventListener('scroll', this.scrollUpdate);
        }
    }

    private scrollUpdate() {
        let newOpacity = 0;

        if (this.backgroundElement && this.pageContentElement && this.doFade) {
            const stepCount = 20;

            newOpacity = this.pageContentElement.scrollTop / this.opaqueHeight;

            // step it
            newOpacity = Math.round(stepCount * newOpacity) / stepCount;

            // clamp 0 - 1
            newOpacity = Math.max(Math.min(newOpacity, 1), 0);
        }

        if (newOpacity !== this.backgroundOpacity) {
            this.backgroundOpacity = newOpacity;
            this.$$(this.backgroundElement).css('opacity', newOpacity);
        }
    }
}
